export default __webpack_public_path__ + "static/media/spei_transaction_number.a23634b1.png";